module.exports = __webpack_public_path__ + "img/online-trx.074cfac7.svg";